import { lazy } from 'react';

export const LessonMaterialsDashboardPage = lazy(() => import('./LessonMaterialsDashboardPage'));
